import React, { useState } from 'react';
import { Button, cn } from 'shadcn-ui';
import { Loader2 } from 'lucide-react';
import { IconButtonProps, IconType } from '../types';
import { ICON_TYPE_MAP } from './iconTypeMap';

const DESTRUCTIVE_ICONS = new Set<IconType>([IconType.TRASH_CAN]);

export default function ShadcnIconButtonLayoutWeb(props: IconButtonProps) {
  const [loading, setLoading] = useState(false);

  const IconComponent = ICON_TYPE_MAP[props.type];
  const size = props.size === 'big' ? 'icon' : 'icon-sm';
  const iconSize = props.size === 'big' ? 'size-4' : 'size-3.5';
  const isDestructive = DESTRUCTIVE_ICONS.has(props.type);

  return (
    <Button
      variant="ghost"
      size={size}
      disabled={props.disabled || loading}
      title={props.title}
      className={cn(
        isDestructive
          ? 'text-gray-400 hover:text-rose-600 hover:bg-rose-50'
          : 'text-gray-400 hover:text-gray-600',
        props.className,
      )}
      data-testid={props.testID}
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!props.disabled && !loading) {
          try {
            setLoading(true);
            await props.onClick();
          } finally {
            setLoading(false);
          }
        }
      }}
    >
      {loading
        ? <Loader2 className={cn(iconSize, 'animate-spin')} />
        : IconComponent && <IconComponent className={iconSize} />}
    </Button>
  );
}
